import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { TikTokBusinessConnection, TikTokBusinessService } from '../../../../services/tiktok-business/tiktok-business.service';

@Component({
  selector: 'mb-brand-tiktok-connect',
  templateUrl: './brand-tiktok-connect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandTikTokConnectComponent implements OnInit {
  businessAccountId = input<string | undefined>(undefined);

  private tiktokBusinessService = inject(TikTokBusinessService);

  connection = signal<TikTokBusinessConnection | null>(null);
  loading = signal<boolean>(true);
  connecting = signal<boolean>(false);
  disconnecting = signal<boolean>(false);
  error = signal<string | null>(null);

  ngOnInit(): void {
    const id = this.businessAccountId();
    if (!id) {
      this.loading.set(false);
      return;
    }
    this.tiktokBusinessService.getConnection(id).subscribe({
      next: (conn) => {
        this.connection.set(conn);
        this.loading.set(false);
      },
      error: () => {
        this.connection.set(null);
        this.loading.set(false);
      },
    });
  }

  connect(): void {
    const id = this.businessAccountId();
    if (!id) return;
    this.connecting.set(true);
    this.error.set(null);
    this.tiktokBusinessService.generateOAuthUrl(id).subscribe({
      next: ({ redirectUrl }) => {
        window.location.href = redirectUrl;
      },
      error: () => {
        this.error.set('Failed to start TikTok connection. Please try again.');
        this.connecting.set(false);
      },
    });
  }

  disconnect(): void {
    const id = this.businessAccountId();
    if (!id) return;
    this.disconnecting.set(true);
    this.error.set(null);
    this.tiktokBusinessService.disconnect(id).subscribe({
      next: () => {
        this.connection.set(null);
        this.disconnecting.set(false);
      },
      error: () => {
        this.error.set('Failed to disconnect. Please try again.');
        this.disconnecting.set(false);
      },
    });
  }
}
